import { combineReducers, configureStore } from "@reduxjs/toolkit";
import appSlice from "./slices/app.slice";
import editorSlice from "./slices/editor.slice";
import formSlice from "./slices/form.slice";
import userSlice from "./slices/user.slice";

const reducer = combineReducers({
  app: appSlice,
  user: userSlice,
  form: formSlice,
  editor: editorSlice,
});

export const store = configureStore({
  reducer,
  devTools: import.meta.env.NODE_ENV !== "production",
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
